import gql from 'graphql-tag';

export default gql`
    query GetStages($input: GetStagesInput) {
        getStages(input: $input) {
            jobStageId
            stage
            overallStage
            wellhead
            status
        }
    }
`;
